import { createAction } from "redux-actions";

import { moduleSlug } from "modules/UserAgents/services/constants";

export const clearUserAgents = createAction(`${moduleSlug}/CLEAR_USER_AGENTS`);

export const getUserAgents = createAction(`${moduleSlug}/GET_USER_AGENTS`);
export const getUserAgentsSuccess = createAction(`${moduleSlug}/GET_USER_AGENTS/SUCCESS`);
export const getUserAgentsError = createAction(`${moduleSlug}/GET_USER_AGENTS/ERROR`);

export const exportUserAgents = createAction(`${moduleSlug}/EXPORT_USER_AGENTS`);

export const setSelectedUserAgents = createAction(`${moduleSlug}/SET_SELECTED_USER_AGENTS`);

export const deleteUserAgents = createAction(`${moduleSlug}/DELETE_USER_AGENTS`);

export const setAddUserAgentDialog = createAction(`${moduleSlug}/SET_ADD_USER_AGENT_DIALOG`);
export const mergeAddUserAgentDialog = createAction(`${moduleSlug}/MERGE_ADD_USER_AGENT_DIALOG`);
export const addUserAgent = createAction(`${moduleSlug}/ADD_USER_AGENT`);